// The bore / site / deck carve runs of a ways doc (GM-CUT KEY): what ways2.js
// WaysNet._bores registers with corridor.js, as a module of its own so the
// ground-tree cut (groundm/bakectx.mjs, engine step groundm_cut) reads it
// without ways2.js's render graph in its key closure (three's materials,
// terrain, the asset queue, … — every client render edit re-keyed the cut).
// Read from the artifacts, nothing derived: no section, no carve.
import { addCorridors } from './corridor.js';

// doc -> { bores2, sites2, decks2 }: the corridor.js runs per key
export function boreRuns(doc) {
  const bores2 = [];
  // the bore carve (S6.a): each emitted bore registers its stations (x,
  // floor, z) and its emitted section profile (ways.json bores[].section,
  // world/emit.js) with corridor.js — which paints the terrain discard from
  // the spans.bin member columns (setSpans), capped under this lining arch
  for (const b of doc.bores || []) {
    if (!b.section || !Array.isArray(b.section.prof)) continue;
    // top: ways.json bores[].section.top (world/emit.js sections, the
    // builder's topAt): per station, metres over that station's floor,
    // min(crown + lift, the clearance cap under a crossing way) - a capped
    // underpass's roof, under the crown; the CUT stops there.
    // cut: ways.json bores[].cut, the lining's cut volume record
    // (world/emit.js, written by world/stage.mjs); a bore emit gave none is
    // cut along its own stations (game/borevol.js, the derived path)
    bores2.push({ bore: true, emitted: true, prof: b.section.prof, top: b.section.top, cut: b.cut, pts: b.x.map((x, i) => [x, b.floor[i], b.z[i]]) });
  }
  // (P2a, APP_ARCHITECT §16) the architect sites' cut (ways.json sites[],
  // world/emit.js siteBuild): rooms only (game/borevol.js site runs); pts
  // the rooms' bbox corners (the carve's reach), nothing derived
  const sites2 = (doc.sites || []).map((s) => {
    const R = s && s.cut && Array.isArray(s.cut.rooms) ? s.cut.rooms : [];
    let x0 = Infinity, x1 = -Infinity, y0 = Infinity, y1 = -Infinity, z0 = Infinity, z1 = -Infinity;
    for (const f of R) for (let k = 0; k + 2 < f.length; k += 3) {
      x0 = Math.min(x0, f[k]); x1 = Math.max(x1, f[k]); y0 = Math.min(y0, f[k + 1]); y1 = Math.max(y1, f[k + 1]); z0 = Math.min(z0, f[k + 2]); z1 = Math.max(z1, f[k + 2]);
    }
    return { bore: true, emitted: true, site: true, prof: [[0, 0]], pts: x0 <= x1 ? [[x0, y0, z0], [x1, y1, z1]] : [], cut: s.cut };
  });
  // the deck carve (S6.b): each emitted deck piece (ways.json decks[],
  // world/emit.js) registers its top (x, top, z) with a flat profile
  // carve_m high over its widest edge — the terrain over a deck top is
  // discarded where spans.bin carries its OPEN members (the skin stood
  // over the top), never synthesised
  const decks2 = [];
  for (const d of doc.decks || []) {
    if (!Array.isArray(d.x) || d.x.length < 2 || !(d.carve_m > 0)) continue;
    const e = Math.max(...d.eL, ...d.eR);
    decks2.push({ bore: true, deck: true, prof: [[e, d.carve_m], [0, d.carve_m]], pts: d.x.map((x, i) => [x, d.top[i], d.z[i]]) });
  }
  return { bores2, sites2, decks2 };
}

// ... registered with corridor.js (bores, sites, decks, in that order) -> the counts
// WaysNet keeps { boreRuns, deckRuns }
export function addBoreRuns(doc) {
  const R = boreRuns(doc);
  addCorridors('bores2', R.bores2);
  addCorridors('sites2', R.sites2);
  addCorridors('decks2', R.decks2);
  return { boreRuns: R.bores2.length, deckRuns: R.decks2.length };
}
